"use strict";
// Adapted version of https://github.com/harfbuzz/harfbuzzjs/blob/master/hbjs.js
// Ideally we would import the TS version from the NPM package, but unfortunately it does not expose the Glyph -> SVG function (https://github.com/harfbuzz/harfbuzzjs/blob/master/harfbuzz.ts).
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHarfBuzz = void 0;
var MEMORY_MODE_WRITABLE = 2;
var PATH_BUFFER_SIZE = 65536;
var MEMORY_PAGES = 400;
var createWasmBridge = function (instance) {
    var mod = instance.exports;
    mod.memory.grow(MEMORY_PAGES);
    var heapu8 = new Uint8Array(mod.memory.buffer);
    var heapu32 = new Uint32Array(mod.memory.buffer);
    var heapi32 = new Int32Array(mod.memory.buffer);
    var utf8Decoder = new TextDecoder('utf8');
    var pathBuffer = mod.malloc(PATH_BUFFER_SIZE);
    var createBlob = function (blob) {
        var blobPtr = mod.malloc(blob.byteLength);
        heapu8.set(new Uint8Array(blob), blobPtr);
        var ptr = mod.hb_blob_create(blobPtr, blob.byteLength, MEMORY_MODE_WRITABLE, blobPtr, mod.free_ptr());
        return {
            ptr: ptr,
            destroy: function () { return mod.hb_blob_destroy(ptr); },
        };
    };
    var createFace = function (blob, index) {
        var ptr = mod.hb_face_create(blob.ptr, index);
        return {
            ptr: ptr,
            destroy: function () { return mod.hb_face_destroy(ptr); },
        };
    };
    var createFont = function (face) {
        var ptr = mod.hb_font_create(face.ptr);
        var glyphToPath = function (glyphId) {
            var svgLength = mod.hbjs_glyph_svg(ptr, glyphId, pathBuffer, PATH_BUFFER_SIZE);
            return svgLength > 0
                ? utf8Decoder.decode(heapu8.subarray(pathBuffer, pathBuffer + svgLength))
                : /* istanbul ignore next */ '';
        };
        var glyphToJson = function (glyphId) {
            var path = glyphToPath(glyphId);
            return path
                .replace(/([MLQCZ])/g, '|$1 ')
                .split('|')
                .filter(function (x) { return x.length; })
                .map(function (x) {
                var row = x.split(/[ ,]/g);
                return {
                    type: row[0],
                    values: row
                        .slice(1)
                        .filter(function (x) { return x.length; })
                        .map(function (x) { return Number(x); }),
                };
            });
        };
        return {
            ptr: ptr,
            glyphToPath: glyphToPath,
            glyphToJson: glyphToJson,
            destroy: function () { return mod.hb_font_destroy(ptr); },
        };
    };
    var utf8Encoder = new TextEncoder();
    var createCString = function (text) {
        var bytes = utf8Encoder.encode(text);
        var ptr = mod.malloc(bytes.byteLength);
        heapu8.set(bytes, ptr);
        return {
            ptr: ptr,
            length: bytes.byteLength,
            free: function () { return mod.free(ptr); },
        };
    };
    var createBuffer = function () {
        var ptr = mod.hb_buffer_create();
        return {
            ptr: ptr,
            addText: function (text) {
                var str = createCString(text);
                mod.hb_buffer_add_utf8(ptr, str.ptr, str.length, 0, str.length);
                str.free();
            },
            guessSegmentProperties: function () {
                return mod.hb_buffer_guess_segment_properties(ptr);
            },
            json: function () {
                var length = mod.hb_buffer_get_length(ptr);
                var result = [];
                var infosPtr32 = mod.hb_buffer_get_glyph_infos(ptr, 0) / 4;
                var positionsPtr32 = mod.hb_buffer_get_glyph_positions(ptr, 0) / 4;
                var infos = heapu32.subarray(infosPtr32, infosPtr32 + 5 * length);
                var positions = heapi32.subarray(positionsPtr32, positionsPtr32 + 5 * length);
                for (var i = 0; i < length; ++i) {
                    result.push({
                        g: infos[i * 5 + 0],
                        cl: infos[i * 5 + 2],
                        ax: positions[i * 5 + 0],
                        ay: positions[i * 5 + 1],
                        dx: positions[i * 5 + 2],
                        dy: positions[i * 5 + 3],
                    });
                }
                return result;
            },
            destroy: function () {
                mod.hb_buffer_destroy(ptr);
            },
        };
    };
    var shape = function (font, buffer) {
        mod.hb_shape(font.ptr, buffer.ptr, 0, 0);
    };
    return {
        createBlob: createBlob,
        createFace: createFace,
        createFont: createFont,
        createBuffer: createBuffer,
        shape: shape,
    };
};
var createHarfBuzz = function (bytes) { return __awaiter(void 0, void 0, void 0, function () {
    var result, harfbuzz;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, WebAssembly.instantiate(bytes)];
            case 1:
                result = _a.sent();
                harfbuzz = createWasmBridge(result.instance);
                return [2 /*return*/, harfbuzz];
        }
    });
}); };
exports.createHarfBuzz = createHarfBuzz;
